export default __webpack_public_path__ + "static/pwc-helvetica-neue-bold-500-bd36da35e3b63d03f87ab2d5a14ec754.woff2";